import { gql } from '@apollo/client';

export const ADD_FREE_TEXT = gql`
  mutation AddFreeText(
    $noteId: String!
    $Section: String!
    $Content: String!
    $SharedId: String!
    $ActionSource: ActionSourceEnum!
    $Order: Int!
    $ComplaintId: Long
  ) {
    addFreeText(
      input: {
        noteId: $noteId
        Section: $Section
        Content: $Content
        SharedId: $SharedId
        ActionSource: $ActionSource
        Order: $Order
        ComplaintId: $ComplaintId
      }
    ) {
      noteId
      Content
    }
  }
`;

export const UPDATE_NOTE_PART = gql`
  mutation UpdateNotePart(
    $noteId: String!
    $selection: String!
    $Content: String!
    $SharedId: String!
    $ActionSource: ActionSourceEnum!
    $UpdatedAt: String!
  ) {
    updateNotePart(
      input: {
        noteId: $noteId
        selection: $selection
        Content: $Content
        SharedId: $SharedId
        ActionSource: $ActionSource
        UpdatedAt: $UpdatedAt
      }
    ) {
      __typename
      ... on FreeText {
        noteId
        selection
        Content
      }
      ... on Sentence {
        noteId
        selection
        Content
      }
    }
  }
`;

export const ADD_CARE_CUE_RESPONSE = gql`
  mutation AddCareCueResponse($input: AddEncounterReminderResponseInput!) {
    addReminderResponse(input: $input) {
      noteId
      dictation
    }
  }
`;

export const UPDATE_REMINDER = gql`
  mutation UpdateEncounterReminder($id: String!, $input: UpdateEncounterReminderInput!) {
    updateEncounterReminder(id: $id, input: $input) {
      id
      status
      reminder {
        id
        category
        name
        alert
        reason
      }
    }
  }
`;

export const SUBMIT_NOTE_REVIEW = gql`
  mutation SubmitNoteReview($input: AddNoteReviewInput!) {
    addNoteReview(input: $input) {
      noteId
      CreatedAt
      UpdatedAt
      overallReview
      specificPoorReviews
      textResponse
    }
  }
`;

export const UPDATE_CODE = gql`
  mutation UpdateCode($updateCodeId: String!, $input: UpdateCodeInput!) {
    updateCode(id: $updateCodeId, input: $input) {
      code
      status
    }
  }
`;

export const ADD_CODE_TO_NOTE = gql`
  mutation AddCodeToNote($noteId: String!, $input: AddCodeInput!) {
    addCodeToNote(noteId: $noteId, input: $input) {
      id
      noteId
      code
      codeSystem
      display
      actionSource
      referenceSelection
      referenceType
      status
    }
  }
`;

export const BATCH_CODES_UPDATE = gql`
  mutation BatchUpdateCodes(
    $rejectCodeInput: UpdateCodeInput!
    $rejectCodeId: String!
    $acceptCodeInput: UpdateCodeInput!
    $acceptCodeId: String!
  ) {
    rejectCodeUpdate: updateCode(input: $rejectCodeInput, id: $rejectCodeId) {
      id
      noteId
      code
      codeSystem
      status
      createdAt
      updatedAt
      createdBy
      updatedBy
      actionSource
      referenceSelection
      referenceType
    }
    acceptCodeUpdate: updateCode(input: $acceptCodeInput, id: $acceptCodeId) {
      id
      noteId
      code
      codeSystem
      status
      createdAt
      updatedAt
      createdBy
      updatedBy
      actionSource
      referenceSelection
      referenceType
    }
  }
`;

export const SAVE_NOTE = gql`
  mutation SaveNote($input: SaveNoteInput!) {
    saveNote(input: $input) {
      noteId
      templateIdSelected
    }
  }
`;

export const ADD_FORM_SELECTION = gql`
  mutation AddFormSelection($input: AddFormSelectionInput!) {
    addFormSelection(input: $input) {
      noteId
      selection
      Section
      EntityType
      IdentityLabel
      SharedId
      ActionSource
      SourceEventName
      UpdatedAt
      Unit
      Data
      DataType
    }
  }
`;
